import type { SVGProps } from 'react';

const SvgReply = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M20 19c-.26 0-.52-.1-.71-.29-3.43-3.43-6.78-3.82-8.29-3.79v2.09c0 .4-.24.77-.62.92-.37.15-.8.07-1.09-.22l-6-6a.996.996 0 0 1 0-1.41l6-6.01c.29-.29.72-.37 1.09-.22s.62.52.62.92v2.08c2.71.33 10 2.03 10 10.92 0 .4-.24.77-.62.92-.12.05-.25.08-.38.08zm-8.88-6.08c1.62 0 4.53.39 7.64 2.7-1.39-6.53-8.43-6.61-8.76-6.61-.55 0-1-.45-1-1v-.59l-3.59 3.59L9 14.6v-.59c0-.48.34-.89.8-.98.06-.01.54-.1 1.32-.1z"
    />
  </svg>
);
export default SvgReply;
